import React from 'react';
import '../css/PrivacyPolicy.css';

const Privacy = () => {
  return (
    <div>


<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>Privacy & Policy</h1>
    </div>
  </div>
</section>

   
      <section className="privacy-policy-section">
        <div className="container">
          <div className="row">
            {/* Privacy Policy Content */}
            <div className="col-lg-9 privacy-policy-content">
              <h3 className='darkcolor'>Introduction</h3>
              <p>
                Woodland Escape  respects the privacy of our guests and online visitors. 
                Protecting your personal information is one of our highest priorities. This Privacy Policy 
                explains how we collect, use, and safeguard your information when you visit our website, 
                <strong> www.woodlandescape.com </strong>. By continuing to use our website, 
                you consent to the practices described in this policy.
              </p>

              <h4 className='darkcolor'>Information We Collect</h4>
              <p>We may collect the following categories of information:</p>
              <ul>
                <li><strong className='darkcolor'>Guest Details:</strong> Name, email, phone number, address, and other contact information.</li>
                <li><strong className='darkcolor'>Booking & Payment Data:</strong> Room reservations, event bookings, payment methods, and transaction history.</li>
                <li><strong className='darkcolor'>Website Usage Data:</strong> IP address, device/browser details, and pages viewed on our website.</li>
              </ul>

              <h4 className='darkcolor'>How We Use Your Information</h4>
              <p>Your information is used for purposes including:</p>
              <ul>
                <li>Managing room reservations, event bookings, and related services.</li>
                <li>Providing updates, confirmations, and guest support.</li>
                <li>Improving the functionality of our website and customizing your user experience.</li>
                <li>Sending offers, newsletters, and promotions (only with your consent).</li>
              </ul>

              <h4 className='darkcolor'>Protection of Your Personal Information</h4>
              <p>
                Woodland Escape  implements robust security practices to protect your personal 
                information. Data is stored securely on servers with proper technical and physical 
                safeguards. We comply with applicable data protection laws in India to maintain 
                confidentiality and integrity of your data.
              </p>

              <h4 className='darkcolor'>Disclaimer of Warranties and Liability</h4>
              <p>
                The content and services on this website are provided on an “AS IS” basis. Woodland Escape  
                does not guarantee uninterrupted or error-free access. We disclaim all warranties, expressed 
                or implied, regarding accuracy, reliability, and fitness of the content or services. 
                Any reliance you place on such materials is strictly at your own risk.
              </p>

              <h4 className='darkcolor'>Guest Details & Consent</h4>
              <p>
                By booking with Woodland Escape , you agree to provide accurate personal details including 
                phone number and address. These details are used solely for booking confirmations, check-ins, 
                and service updates. Marketing communication will only be sent with your prior approval.
              </p>

              <h4 className='darkcolor'>Services and Payments</h4>
              <p>We are not liable for issues arising due to:</p>
              <ul>
                <li>Unauthorized or declined transactions by your bank.</li>
                <li>Exceeding preset financial transaction limits.</li>
                <li>Technical issues with third-party payment providers.</li>
              </ul>
              <p>
                Payments are accepted only in Indian Rupees (INR). Guests may be required to present a valid 
                government-issued photo ID at check-in for verification purposes.
              </p>

              <h4 className='darkcolor'>Promotional Communications</h4>
              <p>
                By contacting our booking desk at <strong>+91 9175577266</strong>, you consent to receive promotional 
                messages related to our ’s services, events, and offers. You may opt out anytime by 
                contacting our team directly.
              </p>

              <h4 className='darkcolor'>Changes to This Privacy Policy</h4>
              <p>
                Woodland Escape  reserves the right to amend this Privacy Policy at its discretion. 
                Any updates will be posted on this page, and your continued use of the website will signify 
                your acceptance of the updated terms.
              </p>

              <h4 className='darkcolor'>Contact Us</h4>
              <p>If you have any questions regarding this Privacy Policy, please contact us at:</p>
              <ul>
                <li><b className='darkcolor'>Phone:</b> <a href="tel:+919175577266">+91 9175577266</a></li>
                <li><b className='darkcolor'>Email:</b> <a href="mailto:woodlandescape01@gmail.com">woodlandescape01@gmail.com</a></li>
              </ul>
            </div>

            {/* Image Column - optional */}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Privacy;
